// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

const SignupConfirmStyle = css`
  .confirmation-label {
    margin: 5px auto 0;
    ::after {
      content: '';
      height: 2px;
      width: 100px;
      background: ${(props) =>
        props.theme.brandSpecificStyles.SIGNUP_CONFIRM.CONFIRMATION_LABEL_BACKGROUND};
      margin: 10px auto 48px;
      display: block;
    }
  }
  .confirm-smiley-logo-wrapper {
    text-align: center;
    padding: ${(props) =>
      props.theme.brandSpecificStyles.SIGNUP_CONFIRM.CONFIRM_SMILEY_LOGO_WRAPPER_PADDING};
    @media ${(props) => props.theme.mediaQuery.large} {
      padding: 31px 0 28px 0;
      ${(props) => (!props.noModal ? `padding: 24px 0 0;` : '')}
    }
  }
  .confirm-smiley-logo-wrapper img {
    width: 66px;
    height: 66px;
    object-fit: contain;
    @media ${(props) => props.theme.mediaQuery.large} {
      width: 74.4px;
      height: 74.4px;
    }
    @media ${(props) => props.theme.mediaQuery.medium} {
      width: 74.4px;
      height: 74.4px;
    }
  }

  .starSize {
    font-size: 50%;
  }

  .confirm-msg {
    margin: 11.8px 0 30.5px;
    font-family: ${(props) => props.theme.fonts.tertiaryUrbaneBold};
    font-size: 55px;
    font-stretch: normal;
    font-style: normal;
    line-height: 1;
    letter-spacing: 1.65px;
    text-align: center;
    color: ${(props) => props.theme.colorPalette.purple['900']};
    @media ${(props) => props.theme.mediaQuery.large} {
      margin: 226.9px 0 339.1px 307px;
    }
    @media ${(props) => props.theme.mediaQuery.medium} {
      margin: 11.8px 0 32.9px;
    }
  }

  .eye-out-msg {
    height: 22px;
    margin: 17.5px auto 0px;
    font-family: Nunito;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.38;
    letter-spacing: normal;
    text-align: center;
    color: #1a1a1a;
    padding: 6px;
    @media ${(props) => props.theme.mediaQuery.large} {
      margin: 109.3px auto 0px;
    }
    @media ${(props) => props.theme.mediaQuery.medium} {
      margin: 32.9px auto 0px;
    }
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      margin: 30.5px auto 0px;
    }
  }

  .sms-reply {
    width: 232px;
    margin: 24px auto 48px;
    font-family: Nunito;
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.22;
    letter-spacing: normal;
    text-align: center;
  }

  .txt-way {
    width: 215px;
    font-family: ${(props) => props.theme.fonts.tertiaryUrbaneBold};
    margin: 32px auto;
    font-size: 25px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.4;
    letter-spacing: 0.75px;
    text-align: center;
    color: ${(props) => props.theme.colorPalette.purple['900']};
  }

  .fun-msg {
    height: 73px;
    margin: 6px auto 0;
    font-family: ${(props) => props.theme.fonts.tertiaryUrbaneBold};
    font-size: 25px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.4;
    letter-spacing: 0.75px;
    text-align: center;
    color: ${(props) => props.theme.colorPalette.purple['900']};
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      height: 65px;
      margin: 0px auto;
    }
    @media ${(props) => props.theme.mediaQuery.small} {
      height: 65px;
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      height: 73px;
      width: 302px;
      margin: 0px auto 150px;
    }
    @media ${(props) => props.theme.mediaQuery.medium} {
      height: 73px;
      width: 302px;
      margin: 0px auto 150px;
    }
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      height: 73px;
      width: 302px;
      margin: 0px auto 50px;
    }
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      padding: 0px 35px;
    }
  }

  .confirmation-image {
    margin: 0 auto 15px;
    display: flex;
    width: 50px;
    height: 50px;
  }
  .first-label {
    margin: 0 60px 5px;
  }
  .redeem-label {
    margin: 0 60px 26px;
  }
  .tnc-label {
    font-size: ${(props) => props.theme.typography.fontSizes.fs10};
    text-align: left;
    margin: 0px 24px 12px;
  }
  .tnc-label .disclaimer {
    text-align: left;
  }
  @media ${(props) => props.theme.mediaQuery.medium} {
    .first-label {
      margin: 0 78px 12px;
    }
    .redeem-label {
      margin: 0 88px 26px;
    }
    .tnc-label {
      margin: 0 78px 183px;
    }
  }
  @media ${(props) => props.theme.mediaQuery.large} {
    margin-top: 31px;
    .confirmation-label {
      margin: 2px auto;
      ::after {
        margin: 24px auto 48px;
      }
    }
    .first-label {
      margin-bottom: 24px;
      margin-top: 0px;
      margin-right: 82px;
      margin-left: 98px;
      padding-top: 9px;
    }
    .tnc-label {
      margin: 0 98px 111px;
    }
  }
  .thank-you__label {
    font-kerning: none;
  }
`;

export default SignupConfirmStyle;
